import React from "react"
import { Box, Container, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import SEO from "components/SEO"
import Image from "next/image"

import { Phone, Email } from "components/i18n/Contact"
import BackgroundImage from "/images/imprint-img.png"

import { bankName, IBAN, BIC } from "@secureo/common/config/bankAccountDetails"

const useStyles = makeStyles()(() => ({
	root: {
		"& p": {
			opacity: 0.75,
			margin: 0,
		},
	},
	headerBgImage: {
		position: "absolute",
		top: 0,
		right: 0,
		height: "650px",
		width: "50vw",
		overflow: "hidden",
		zIndex: 0,
		filter: "brightness(100%)",
		"@media only screen and (max-width: 960px)": {
			filter: "brightness(60%)",
			width: "90vw",
			opacity: 0.4,
		},
	},
}))

const ImprintPage = () => {
	const { classes } = useStyles()

	return (
		<>
			<SEO asPath={"/imprint"} title="Impressum" appendLocalizedShopNameWithPipe />
			<Box py={5} style={{ background: "#042C33", color: "#fff" }} className={classes.root}>
				<div>
					<div className={classes.headerBgImage}>
						<Image
							alt="Kontakt"
							src={BackgroundImage}
							quality={100}
							fill
							sizes="100vw"
							style={{
								objectFit: "cover",
							}}
						/>
					</div>
					<Container style={{ position: "relative", zIndex: 1 }}>
						<Box py={5}>
							<h1 style={{ fontSize: 45 }}>Impressum</h1>
							<h2>Secureo GmbH</h2>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={6} md={4}>
									<Box mt={4}>
										<strong>Anschrift & Firmensatz</strong>
									</Box>
									<p>Im Moos 19, 6067 Absam</p>
									<Box mt={4}>
										<strong>Telefon</strong>
									</Box>
									<p>
										<Phone />
									</p>
									<Box mt={4}>
										<strong>UID Nr.</strong>
									</Box>
									<p>ATU68967825 | DE297458371</p>
									<Box mt={4}>
										<strong>Bankverbindung</strong>
									</Box>
									<p>{bankName}</p>
									<p>IBAN: {IBAN}</p>
									<p>BIC: {BIC}</p>
								</Grid>
								<Grid item xs={12} sm={6} md={4}>
									<Box mt={4}>
										<strong>Geschäftsführerin</strong>
									</Box>
									<p>Caroline Reinalter</p>

									<Box mt={4}>
										<strong>E-Mail</strong>
									</Box>
									<p>
										<Email />
									</p>
									<Box mt={4}>
										<strong>Firmenbuchnr.</strong>
									</Box>
									<p>422359t</p>
									<Box mt={4}>
										<strong>Gegenstand des Unternehmens</strong>
									</Box>
									<p>Handel mit Sicherheitsprodukten</p>
								</Grid>
							</Grid>
						</Box>
					</Container>
				</div>
				<Container>
					<Box my={5}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<div>
									<strong>
										Mitglied der WKÖ, Tiroler Landesgremium des Versand-,
										Internet- und allgemeinen Handels.
									</strong>
								</div>
							</Grid>
							<Grid item xs={12} sm={6} style={{ opacity: 0.8 }}>
								<p>
									Die auf diesem Server bereitgestellten Informationen und
									Gestaltungselemente sind an das Urheberrecht gebunden. Ohne die
									vorherige schriftliche Genehmigung von Secureo GMBH ist es
									untersagt, Inhalte dieses Web-Servers teilweise oder komplett zu
									vervielfältigen oder auf andere Art zu verwenden.
								</p>

								<p style={{ marginTop: 20 }}>
									Sämtliche Informationen wurden sorgfältig recherchiert und
									aufbereitet. Secureo GMBH übernimmt jedoch keine Garantie für
									die Korrektheit und Vollständigkeit der Informationen.{" "}
								</p>
							</Grid>
							<Grid item xs={12} sm={6} style={{ opacity: 0.8 }}>
								<p>
									Für jeglichen Schaden, der direkt oder indirekt in Zusammenhang
									mit der Nutzung, dem Missbrauch oder der Funktionalität dieses
									Web-Servers oder der darin angebotenen Informationen steht,
									übernimmt SecureoDE GMBH keinerlei Haftung.
								</p>
								<p style={{ marginTop: 20 }}>
									Verweise auf andere Internetauftritte sind nicht als Empfehlung
									von Secureo GMBH für das jeweilige Unternehmen, dessen Produkte
									oder Dienstleistungen zu verstehen und können somit nicht für
									selbige haftbar gemacht werden.
								</p>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>
		</>
	)
}

export default ImprintPage
